import { useAutomationSubscriptionBundlesQuery } from 'generated/graphql';

import { makeAsync } from '@client/new/helpers/async';
import type { Async } from '@client/new/helpers/types';

/** A published subscription product the OTP sequence can pitch. Same
 *  candidate set creator-api's enable gate counts. */
export type BundleOption = { id: string; title: string };

export const useAutomationBundlesModel = (
  creatorId: number,
): Async<BundleOption[], { message: string; retry: () => Promise<void> }> => {
  const query = useAutomationSubscriptionBundlesQuery({
    variables: { creatorId },
    fetchPolicy: 'cache-first',
  });

  if (query.error) {
    return makeAsync.error({
      message: query.error.message,
      retry: async () => {
        await query.refetch();
      },
    });
  }
  if (query.loading && !query.data) return makeAsync.fetching();
  if (!query.data) return makeAsync.notFetched();
  return makeAsync.fetched(
    query.data.bundle
      .filter((bundle) => bundle.status === 'PUBLISHED')
      .map((bundle) => ({ id: String(bundle.id), title: bundle.title })),
  );
};
